import { render } from 'less';
import React, { useEffect, useState } from 'react';
import { Modal, Tag, Divider, message, Button } from 'antd';
import './index.less';
import {
    backstageList, backstageInsDeal
} from '../../../../api/inspiration';
import WaterFall from '../../../../component/WaterFall';
import copy from "copy-to-clipboard";
import { useBoolean } from 'ahooks';
import useUrlState from '@ahooksjs/use-url-state';
const pageSize = 25
const Old = (props) => {
    const {match,history,location} = props
    const [detailList, setDetailList] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [classifyLoading, setClassifyLoading] = useState(false);
    const [currentPage,setCurrentPage] = useState(1)
    const [buchongVisible,{setTrue,setFalse}] = useBoolean(false)
    const [state, setState] = useUrlState({ searchWordId:0 });

    useEffect(()=>{
        window.removeEventListener('message',this)
        window.addEventListener('message', handleMessage);
        window.opener.postMessage('11111')
    },[])

    useEffect(()=>{
        queryData()
    },[currentPage])

    useEffect(()=>{
        // const _arr = new Array()
        // detailList.forEach((item,index)=>{
        //     _arr.push(item.insId)
        // })
        // setSelectedIds(_arr)
        window.opener.postMessage({
            name: 'oldDetailListLength',
            data: detailList.length
        })
    },[detailList])

    const handleMessage = (e) => {
        switch (e.data.name) {
            case 'currentPage':
                setCurrentPage(e.data.data)
                break
        }
    }

    const queryData = async () => {
        const res = await backstageList({page:currentPage,type:2,pageSize: pageSize});
        if (res?.error?.code == 0 && res.data) {
            setDetailList(res.data.inspirations ?? []);
        } else {
            setDetailList([]);
        }
    }

    const click2copy = (e,insId) => {
        e.stopPropagation();
        if (copy(insId))
            message.success('复制成功')
        else
            message.error('复制失败')
    }

    function displayWaterFallRender(v) {
        return <div className='waterfall_tags_wrap'>
            <Tag color="magenta" onClick={(e)=>click2copy(e,v.insId)}>{v.insId}</Tag>
        </div>
    }
    function onImgSelect(v, isSelect) {
    }

    const selectAll = () => {
        let _arr = []
        if (selectedIds.length >= pageSize) {
            
        } else {
           
            detailList.forEach((item,index)=>{
                _arr.push(item.insId)
            })
        }
        setSelectedIds(_arr)
        
    }

    const buchong = () => {
        backstageInsDeal({
            searchWordId: state.searchWordId,
            oldInsIdList: selectedIds
        }).then(res=>{
            if (res.error.code == 0) {
                message.success('成功')
            }else{
                message.error('失败')
            }
        }).catch(e=>{
            message.error('页面错误')
        }).finally(()=>setFalse())
    }

    return (
        <div className='cal_main'>
            <div className='topMenu'>
                <Button onClick={()=>selectAll()}>全选</Button>
                <Button onClick={()=> {
                    if (selectedIds.length<=0) {
                        return message.warning('未选择图片')
                    }
                    // setTrue()
                    buchong()
                }}>补充入库</Button>
                <Divider orientation="center">旧图</Divider>
            </div>
            <div className='imgList'>
                <WaterFall
                    list={detailList}
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                    displayRender={displayWaterFallRender}
                    onSelect={onImgSelect}
                    disabled={classifyLoading}
                />
            </div>
            <Modal
                title='确认提交'
                visible={buchongVisible}
                onOk={buchong}
                okText='确定'
                onCancel={setFalse}
                cancelText='取消'
                bodyStyle={{display: 'none'}}
            >
            </Modal>
        </div>
    )
}

export default Old